import styled from "styled-components";
import { toAbsoluteUrl } from "../../utils/assetHelper";

export const Wrapper = styled.div`
.bio-container{
margin-top: 75px;
padding:0;
background: url(${toAbsoluteUrl('/media/aboutheader.png')}) no-repeat;
background-size: 100% 100%;
height: 480px;

@media screen and (max-width:450px) {
height: 300px;
background-size: 100% 100%;
}
}
`

export const AboutHeader = styled.div`
margin-top: 20px;
h1{
    font-size: 48px;
    font-weight: 800;
    text-align: center;
    color: #fff;

    span{
        color: var(--primary-color);
    }
}
`

export const AboutContent = styled.div`
.about-wrapper {
width: 98vw;
margin: 0 auto;
display: grid;
gap: 16px;
padding: 60px 96px;
border-radius: 20px;
background: linear-gradient(102deg, rgba(63, 27, 208, 0.05) 4.47%, rgba(215, 76, 16, 0.05) 54.56%);
margin-bottom: 32px;
margin-top: 32px;

@media screen and (max-width:1100px) {
padding: 60px 1.2rem;

h2 {
font-size: 36px !important;
}

h3 {
font-size: 26px !important;
}

}

h2 {
font-size: 48px;
font-style: normal;
font-weight: 800;
line-height: 60px;
text-align: center;
}

h3 {
margin-top: 16px;
margin-bottom: 16px;
font-size: 32px;
font-style: normal;
font-weight: 600;
text-align: left;
color: var(--dark-grey);
text-decoration: underline;
}

h5{
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: 24px;
text-align: left;
color: var(--primary-color);
}

p{
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 28px;
text-align: left;

span{
    color: var(--primary-color);
    font-weight: 700;
}
}

ul {
display: grid;
gap: 5px;
padding-left: 25px;
margin: 16px 0;
list-style: disc;
font-size: 20px;
font-weight: 600;
color: var(--primary-color);
}

}

@media screen and (min-width:2160px) {
    .background-image{
        height: 800px !important;
    }
}


`